import React from 'react';
import { CompareFigure } from 'shared/ui/Figure';

export type SolutionFigureProps = {
  label: string;
  value: string;
  current?: string;
  tone?: 'brand';
  loading?: boolean;
};

/** Current-vs-Custom pairing (SpecialPricingMetrics.jsx, Ruling P8). With no
 *  `current` this is exactly a plain Figure — the common case, no baseline.
 *  The pair markup now lives in shared/ui CompareFigure so the live rail can
 *  show exec metric overrides (CONF-212) the same way. */
export function SolutionFigure(props: SolutionFigureProps) {
  return <CompareFigure {...props} />;
}
